import { render, staticRenderFns } from "./onebox-directoryfile-scrolling-new.vue?vue&type=template&id=77e85125&scoped=true&"
import script from "./onebox-directoryfile-scrolling-new.vue?vue&type=script&lang=js&"
export * from "./onebox-directoryfile-scrolling-new.vue?vue&type=script&lang=js&"
import style0 from "./onebox-directoryfile-scrolling-new.vue?vue&type=style&index=0&id=77e85125&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e85125",
  null
  
)

export default component.exports